import React from 'react'
import './marketplace.css'
import { useTimer } from 'react-timer-hook';
import Footer from '../../Home/Home_modules/Footerr/footer'
import Count from "../../Components/Count.js";


function MyTimer({ expiryTimestamp }) {
    const {
      seconds,
      minutes,
      hours,
      days,
    } = useTimer({ expiryTimestamp, onExpire: () => console.warn('onExpire called') });
  
  
    return (
      <div className="csoon-time" style={{textAlign: 'center'}}>
          <div>
          <span className="csoon-cdown"><Count /></span>
          </div>
          <div className="csoon-label">
          <div><span className="csoon-cstamp">days</span></div>
          <div><span className="csoon-cstamp">hr</span></div>
          <div><span className="csoon-cstamp">min</span></div>
          <div><span className="csoon-cstamp">sec</span></div>
      </div>
      </div>
    );
  }
  

function Marketplace() {
    const time = new Date();
    time.setSeconds(time.getSeconds() + 6000000); // set timer
    return (
        <>
        <div className="mplace-page">
            <div className="mplace-header">
            <h1>COMING SOON IN</h1>
            </div>
            <div className="mplace-csoon">
                <div className="csoon-content">
                <MyTimer expiryTimestamp={time} />
                </div>
            </div>
        </div>
        <Footer/>
        </>
    )
}

export default Marketplace
